
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["music_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"200","height":"200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M512 56.879c251.345 0 455.121 203.776 455.121 455.121S763.345 967.121 512 967.121 56.879 763.345 56.879 512 260.655 56.879 512 56.879zm30.022 170.682h-3.165a26.577 26.577 0 00-26.252 23.645l-.326 1.862-.279 1.35V596.06a105.332 105.332 0 00-49.804-12.94h-71.028a106.729 106.729 0 000 213.318h71.028a106.729 106.729 0 00106.636-106.682c0-2.42-.559-4.701-.745-7.075h.745V305.245l76.335 44.125a28.346 28.346 0 0038.818-10.426 28.486 28.486 0 00-10.333-38.912l-116.456-67.165a26.205 26.205 0 00-15.22-5.306zM462.242 640C489.659 640 512 662.342 512 689.804c0 27.415-22.342 49.757-49.804 49.757h-71.028c-27.462 0-49.804-22.342-49.804-49.804 0-27.415 22.342-49.757 49.804-49.757h71.028z","fill":"#333"}})])
          )
        }
      }
    